// configurator-copyconfig.js
// Copy Config (owner request 2026-10-20). Mounts a "Copy config" link under
// the Build Summary pane CTAs (desktop) and inside the mobile bar expander
// ledger. Clicking copies the CURRENT configuration to the clipboard as a
// plain string. Nothing is minted: no bundle, no draft order, no network
// call. Intended for phone orders: the rep configures here, copies the
// string, and pastes it into Quantify's Load Bundle (sales/new) to prefill
// a sales doc without rebuilding the order in the sales wizard.
//
// String format: pipe separated segments, every segment {qsku}x{qty}
// (the same qty encoding the eBay bridge child SKUs use), in ledger order:
// the chassis kit and the whl-create-bundle lines exactly as buildLines()
// returns them, then resolved tray lines aggregated per tray qsku from the
// same trayMap the pane and baseTotalCents use, then a trailing W:{tier}
// segment carrying the selected warranty label. Example:
//   BP-011932x1|P-0000123x2|M-0000149x4|R-0000020x1|D-0000055x8|
//   PS-0000002x2|N-0000040x1|O-0000001x1|T-0000006x8|W:1 Year Warranty
// Because the lines come from buildLines(), the string matches what Add To
// Cart / Add To Quote would send the backend for this same configuration.
//
// Reads only public members of the server-configurator-quantify element
// (buildLines, selectedDrives, trayMap, selectedWarrantyLabel,
// missingSelections). Writes nothing back and never touches recalc.
// Gates on #q-pane, so it no-ops on legacy markup. Rollback is removing
// the script tag in sections/configurator-product.liquid.

(function () {
  const TAG = 'server-configurator-quantify';

  function configString(el) {
    const segs = [];
    const lines = typeof el.buildLines === 'function' ? el.buildLines() : [];
    lines.forEach((l) => {
      if (!l || !l.sku) return;
      segs.push(`${l.sku}x${Math.max(1, parseInt(l.qty) || 1)}`);
    });
    if (el.trayMap && el.selectedDrives && typeof el.selectedDrives.forEach === 'function') {
      const trayAgg = new Map();
      el.selectedDrives.forEach((d) => {
        (el.trayMap[d.ff] || []).forEach((t) => {
          const add = (t.qty_per_drive || 0) * d.qty;
          if (add <= 0 || !t.tray_qsku) return;
          trayAgg.set(t.tray_qsku, (trayAgg.get(t.tray_qsku) || 0) + add);
        });
      });
      trayAgg.forEach((qty, qsku) => segs.push(`${qsku}x${qty}`));
    }
    const tier = typeof el.selectedWarrantyLabel === 'function' ? el.selectedWarrantyLabel() : '';
    if (tier) segs.push(`W:${tier}`);
    return segs.join('|');
  }

  async function copyText(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) { /* fall through to the textarea path */ }
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  }

  function makeControl(el) {
    const wrap = document.createElement('div');
    wrap.className = 'q-copycfg';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'q-copycfg-btn';
    btn.textContent = 'Copy config';
    btn.title = 'Copy this configuration as a text string for Quantify';
    const note = document.createElement('span');
    note.className = 'q-copycfg-note';
    note.setAttribute('aria-live', 'polite');
    wrap.appendChild(btn);
    wrap.appendChild(note);
    btn.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const text = configString(el);
      if (!text) {
        note.textContent = 'Nothing to copy';
        return;
      }
      const ok = await copyText(text);
      const missing = typeof el.missingSelections === 'function' ? el.missingSelections() : [];
      if (ok) {
        note.textContent = missing.length ? `Copied (${missing.length} incomplete)` : 'Copied';
      } else {
        // Last resort: show the string so it can be copied by hand.
        window.prompt('Copy this configuration string:', text);
        note.textContent = '';
      }
      clearTimeout(note._t);
      note._t = setTimeout(() => { note.textContent = ''; }, 2500);
    });
    return wrap;
  }

  function mount() {
    const el = document.querySelector(TAG);
    const pane = document.getElementById('q-pane');
    if (!el || !pane) return;
    if (document.querySelector('.q-copycfg')) return;

    const style = document.createElement('style');
    style.textContent = `
      .q-copycfg { display: flex; align-items: center; justify-content: center; gap: 0.5rem; margin-top: 0.6rem; font-size: 0.8rem; }
      .q-copycfg-btn { background: none; border: none; padding: 0; color: inherit; opacity: 0.75; text-decoration: underline; cursor: pointer; font: inherit; font-size: 0.8rem; }
      .q-copycfg-btn:hover { opacity: 1; }
      .q-copycfg-note { opacity: 0.75; min-width: 1px; }
      .q-bar-expander .q-copycfg { margin: 0.5rem 0 0.25rem; }
    `;
    document.head.appendChild(style);

    // Desktop: under the pane CTAs (appended by setupSummaryPane on the
    // first recalc; appendChild lands after them whenever this runs).
    pane.appendChild(makeControl(el));

    // Mobile: inside the bar expander ledger, after the totals block.
    const exp = document.getElementById('q-bar-expander');
    const ledger = exp ? exp.querySelector('.ledger') : null;
    if (ledger) ledger.appendChild(makeControl(el));
  }

  function start() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined(TAG).then(mount).catch(mount);
    } else {
      mount();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
